// CapaActionStatus Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { capaActionStatusConfig } from './capaActionStatusConfig';
import { createCapaActionStatusValidation } from './capaActionStatusValidation';

/**
 * Initialize the capaActionStatus module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  capaActionStatusConfig,
  createCapaActionStatusValidation
);

/**
 * Create the CapaActionStatusPage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const CapaActionStatusPage = createModulePage(
  initializedConfig,
  {
    displayName: 'CapaActionStatusPage',
    description: 'CAPA Action Status Management System - Manage CAPA action statuses for tracking action progress'
  }
);

export default CapaActionStatusPage;
